import React from "react";
import { Modal, Typography } from "antd";
import { CLOTHING_CATEGORY } from "../constants";
import QuantityStep from "./QuantityStep";
import PaymentMethodSelect from "./PaymentMethodSelect";
import ClothingSelectors from "./ClothingSelectors";
import CollectiveChargeSection from "./CollectiveChargeSection";
import PurchaseSummary from "./PurchaseSummary";

const { Title } = Typography;

export default function PurchaseModal({ purchase, users }) {
  const {
    product,
    open,
    closeModal,
    selection,
    updateSelection,
    selectedUsers,
    setSelectedUsers,
    requesterId,
    confirming,
    confirm,
    isClothing,
    isCollective,
    totalCost,
    perUserCost,
    canConfirm,
  } = purchase;

  if (!product) return null;

  return (
    <Modal
      title={<Title level={5} style={{ margin: 0 }}>Canjear: {product.name}</Title>}
      open={open}
      onCancel={closeModal}
      onOk={confirm}
      okText="Confirmar Canje"
      cancelText="Cancelar"
      confirmLoading={confirming}
      okButtonProps={{ disabled: !canConfirm, size: "large" }}
      cancelButtonProps={{ size: "large" }}
      centered
      width="min(92vw, 480px)"
      bodyStyle={{ maxHeight: "65vh", overflowY: "auto", paddingRight: 4 }}
    >
      <QuantityStep
        quantity={selection.quantity}
        maxStock={product.stock}
        onChange={(quantity) => updateSelection({ quantity })}
      />

      <PaymentMethodSelect
        value={selection.paymentMethod}
        onChange={(paymentMethod) => updateSelection({ paymentMethod })}
      />

      {product.category === CLOTHING_CATEGORY && (
        <ClothingSelectors
          product={product}
          size={selection.size}
          color={selection.color}
          onSizeChange={(size) => updateSelection({ size })}
          onColorChange={(color) => updateSelection({ color })}
        />
      )}

      {Boolean(product.is_colective) && (
        <CollectiveChargeSection
          isCollective={isCollective}
          chargeType={selection.chargeType}
          onChargeTypeChange={(chargeType) => updateSelection({ chargeType })}
          users={users}
          selectedUsers={selectedUsers}
          onSelectedUsersChange={setSelectedUsers}
          requesterId={requesterId}
        />
      )}

      <PurchaseSummary
        isColective={Boolean(product.is_colective)}
        paymentMethod={selection.paymentMethod}
        isCollective={isCollective}
        totalCost={totalCost}
        perUserCost={perUserCost}
      />
    </Modal>
  );
}
